export const ALL_PIPELINES_VALUE = 'ALL_PIPELINES_VALUE';
export const ALL_PIPELINES_VALUE_FROM_QUERY_PARAM = 'all';